import { mapActions, mapGetters } from 'vuex';

export default {
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.hideNotification();
      }
    },
  },
  computed: {
    ...mapGetters({
      notifications: 'notifications/getNotifications',
      isOpen: 'notifications/isOpen',
      notificationType: 'notifications/getNotificationType',
    }),
  },
  methods: {
    ...mapActions({
      setNotification: 'notifications/SETNOTIFICATION',
      displayNotification: 'notifications/DISPLAYNOTIFICATION',
      hideNotification: 'notifications/HIDENOTIFICATION',
    }),
    showNotification(type, messages) {
      const lines = messages.map(m => ({ text: m }));
      if (lines.length > 0) {
        this.setNotification(
          {
            notificationType: type,
            messages: lines,
          },
        );
      } else {
        this.hideNotification();
      }
    },
  },
};
